// Servicios API para admin y otras utilidades
import { apiClient } from '../services/api';
import { API_BASE_URL } from '../config';

// Admin Stores API
export const adminStoresAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/stores`, params),
  
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/stores/${id}`),
  
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/stores`, data),
  
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/stores/${id}`, data),
  
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/stores/${id}`),
  
  toggle: (id, isParticipating) => apiClient.post(
    `${API_BASE_URL}/api/admin/stores/${id}/toggle`,
    { is_participating: isParticipating }
  ),
  
  // Genera o rota el PIN de caja. La respuesta trae el PIN en claro y es la
  // única vez que se puede ver: en la base solo queda el hash.
  rotateAccessPin: (id) => apiClient.post(`${API_BASE_URL}/api/admin/stores/${id}/access-pin`, {}),

  toggleFeatured: (id, isFeatured) => apiClient.post(
    `${API_BASE_URL}/api/admin/stores/${id}/toggle-featured`,
    { is_featured: isFeatured }
  ),
};

// Admin Benefits API
export const adminBenefitsAPI = {
  getAll: () => apiClient.get(`${API_BASE_URL}/api/admin/benefits`),
  
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/benefits`, data),
  
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/benefits/${id}`, data),
  
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/benefits/${id}`),
};

// Admin Statistics API
export const adminStatsAPI = {
  /* Las tres aceptan `{ start, end }`. Sin ellos devuelven el histórico
     completo, que es como se llamaban antes de que el selector de periodo del
     tablero sirviera para algo. */
  getOverview: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/statistics/overview`, params),

  getTopStores: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/statistics/top-stores`, params),

  getRecentActivity: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/statistics/recent-activity`, params),

  getDailyStats: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/statistics/daily`, params),
  getRedemptionsSummary: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/stats/redemptions/summary`, params),
  getRedemptionsDetail: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/stats/redemptions`, params),
};

// QR API (para QRSettings)
export const qrAPI = {
  getSettings: () => apiClient.get(`${API_BASE_URL}/api/qr/settings`),
};

export const adminQRAPI = {
  // Dos duraciones: la del socio y la de quien usa su beneficio de bienvenida.
  updateSettings: (duration, durationGratuito) => apiClient.put(
    `${API_BASE_URL}/api/admin/qr/settings`,
    { duration, duration_gratuito: durationGratuito }
  ),
};

// Admin Brands API
export const adminBrandsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/brands`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/brands/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/brands`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/brands/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/brands/${id}`),
};

// Admin Promotions API
export const adminPromotionsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promotions`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/promotions/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/promotions`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/promotions/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/promotions/${id}`),
};

// Admin Ads API
export const adminAdsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/ads`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/ads/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/ads`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/ads/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/ads/${id}`),
};

// Admin Subscribers API (read-only)
export const adminSubscribersAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/subscribers`, params),
};

// Admin QR Redemptions API (read-only)
// Enlaces de referido: closers y canales, con su embudo.
export const adminEnlacesAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/enlaces`, params),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/enlaces`, data),
  update: (tipo, id, data) => apiClient.put(`${API_BASE_URL}/api/admin/enlaces/${tipo}/${id}`, data),
};

// Lo que necesita atención del administrador: PIN de caja y ahorros raros.
export const adminAvisosAPI = {
  getAll: () => apiClient.get(`${API_BASE_URL}/api/admin/avisos`),
};

export const adminQrRedemptionsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/qr-redemptions`, params),
};

// Admin Outlet Map API
export const adminOutletMapAPI = {
  getMap: () => apiClient.get(`${API_BASE_URL}/api/admin/outlet-map`),
};

// Admin Featured Stores API (extended)
export const adminFeaturedStoresAPI = {
  getFeatured: () => apiClient.get(`${API_BASE_URL}/api/admin/featured-stores`),
  updateFeature: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/stores/${id}/feature`, data),
};

// Admin Promoters API
export const adminPromotersAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/promoters`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/promoters/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/promoters/${id}`),
  updateShowInDashboard: (id, showInDashboard) => apiClient.put(
    `${API_BASE_URL}/api/admin/promoters/${id}/show-in-dashboard`,
    { show_in_dashboard: showInDashboard }
  ),
};

// Admin Promoter Metrics API
export const adminPromoterMetricsAPI = {
  getOverview: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/metrics/overview`, params),
  getPromoterMetrics: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}/metrics`, params),
  getTopPromoters: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/metrics/top`, params),
  getRegisteredUsers: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}/registered-users`, params),
  getPaidUsers: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}/paid-users`, params),
  getDashboardPromoters: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/metrics/dashboard`, params),
};

// Closer Panel API (rol closer)
export const closerAPI = {
  getMe: () => apiClient.get(`${API_BASE_URL}/api/closer/me`),
  getSummary: () => apiClient.get(`${API_BASE_URL}/api/closer/summary`),
  getActivations: (params = {}) => apiClient.get(`${API_BASE_URL}/api/closer/activations`, params),
  getRanking: (params = {}) => apiClient.get(`${API_BASE_URL}/api/closer/ranking`, params),
};

// Validación pública de código de closer (para /signup?code=X)
export const closerCodeAPI = {
  validate: (code) => apiClient.get(`${API_BASE_URL}/api/closer-codes/validate`, { code }),
};

// Admin Closers API
export const adminClosersAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/closers`, params),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/closers`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/closers/${id}`, data),
  toggle: (id) => apiClient.post(`${API_BASE_URL}/api/admin/closers/${id}/toggle`, {}),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/closers/${id}`),
  getActivations: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/closers/${id}/activations`, params),
  getMetrics: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/closers/metrics`, params),
  getSettings: () => apiClient.get(`${API_BASE_URL}/api/admin/closers/settings`),
  updateSettings: (data) => apiClient.put(`${API_BASE_URL}/api/admin/closers/settings`, data),
};

// Admin Commission Tiers API
export const adminCommissionTiersAPI = {
  getAll: () => apiClient.get(`${API_BASE_URL}/api/admin/commission-tiers`),
  update: (tiers) => apiClient.put(`${API_BASE_URL}/api/admin/commission-tiers`, { tiers }),
  updateMode: (mode) => apiClient.put(`${API_BASE_URL}/api/admin/commission-tiers/mode`, { mode }),
};

// Admin Announcements API
export const adminAnnouncementsAPI = {
  getAll: () => apiClient.get(`${API_BASE_URL}/api/admin/announcements`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/announcements`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/announcements/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/announcements/${id}`),
  publish: (id) => apiClient.post(`${API_BASE_URL}/api/admin/announcements/${id}/publish`, {}),
};

